import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Get the root element
const container = document.getElementById('root');
const root = createRoot(container);

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Handle production error logging
if (process.env.NODE_ENV === 'production') {
  console.error = (...args) => {
    // Send to error tracking service if needed
    console.log('Production Error:', ...args);
  };
}
